import RequestSummarySectionResourceModel from '../../generated/types/model/resource/RequestSummarySectionResourceModel';

export default class RequestSummarySectionResourceViewModel extends RequestSummarySectionResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
